// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCikpP8_2Wu_3aTRw6IbO6lKA4sySjMalc',
    authDomain: 'crewhouse-app.firebaseapp.com',
    //databaseURL: '<your-database-URL>',
    projectId: 'crewhouse-app',
    storageBucket: 'crewhouse-app.appspot.com',
    messagingSenderId: '32336417816',
    appId: '1:32336417816:web:46f4407a9de29041b09f6d',
    measurementId: 'G-KJQ8P1S60L'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
